import React from 'react';
import PropTypes from 'prop-types';
import Label from '../../Label';

var TextLabel = function TextLabel(_ref) {
  var children = _ref.children;
  return React.createElement(
    Label,
    { appearance: 'T1.2', dataHook: 'notification-label' },
    children
  );
};

TextLabel.propTypes = {
  children: PropTypes.any
};

TextLabel.displayName = 'Notification.TextLabel';

export default TextLabel;
//# sourceMappingURL=TextLabel.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Notification/TextLabel/TextLabel.js